import React, { useMemo } from "react";
import { Form } from "react-bootstrap";

const ServizioDettagliForm = ({ type, formik, getInputClasses, formFields }) => {
  const selectedType = Number(type);
  const isCongresso = selectedType === 1;
  const isSponsorizzazione = selectedType === 2;
  const isTrasferta = selectedType === 3;
  const isMaterialeTipografico = selectedType === 4;
  const sponsorizzazioneOptions = [
    { value: "Contributo libero", label: "Contributo libero" },
    { value: "Stand", label: "Stand" },
    { value: "Esposizione Roll-Up", label: "Esposizione Roll-Up" },
    { value: "Logo su locandina", label: "Logo su locandina" },
    { value: "Altro", label: "Altro" },
  ];
  const congressoOptions = [
    { value: "Solo Iscrizione", label: "Solo Iscrizione" },
    { value: "Solo Hotel", label: "Solo Hotel" },
    { value: "Iscrizione+Hotel", label: "Iscrizione+Hotel" },
  ];
  const materialeTipograficoOptions = [
    { value: "Timbro", label: "Timbro" },
    { value: "Ricettario", label: "Ricettario" },
    { value: "Biglietti da Visita", label: "Biglietti da Visita" },
    { value: "Altro", label: "Altro" },
  ];

  // Helpers per data locale in formato YYYY-MM-DD (evita toISOString/UTC)
  const formatLocalYMD = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  const addDays = (date, days) => {
    const d = new Date(date.getTime());
    d.setDate(d.getDate() + days);
    return d;
  };

  const minStartDateObj = useMemo(() => addDays(new Date(), 7), []);
  const minStartDateStr = useMemo(() => formatLocalYMD(minStartDateObj), [minStartDateObj]);
  const minTwentyOneObj = useMemo(() => addDays(new Date(), 21), []);

  return (
    <>
      {/* Sponsorizzazione: mostra prima Tipo Sponsorizzazione */}
      {isSponsorizzazione && (
        <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
          <Form.Label className="col-12">{formFields["tipoSponsorizzazione"].label}</Form.Label>
          <select
            name="tipoSponsorizzazione"
            className={`form-control ${getInputClasses("tipoSponsorizzazione")}`}
            {...formik.getFieldProps("tipoSponsorizzazione")}
          >
            <option value="">Seleziona tipo...</option>
            {sponsorizzazioneOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          {formik.touched["tipoSponsorizzazione"] && formik.errors["tipoSponsorizzazione"] ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors["tipoSponsorizzazione"]}</div>
            </div>
          ) : null}
        </Form.Group>
      )}

      {/* Materiale Tipografico: select dedicato */}
      {isMaterialeTipografico && (
        <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
          <Form.Label className="col-12">{formFields["tipoMaterialeTipografico"].label}</Form.Label>
          <select
            name="tipoMaterialeTipografico"
            className={`form-control ${getInputClasses("tipoMaterialeTipografico")}`}
            {...formik.getFieldProps("tipoMaterialeTipografico")}
          >
            <option value="">Seleziona materiale...</option>
            {materialeTipograficoOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          {formik.touched["tipoMaterialeTipografico"] && formik.errors["tipoMaterialeTipografico"] ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors["tipoMaterialeTipografico"]}</div>
            </div>
          ) : null}
        </Form.Group>
      )}

      {/* Congresso: select per Iscrizione/Hotel */}
      {isCongresso && (
        <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
          <Form.Label className="col-12">{formFields["tipoIscrizioneCongresso"].label}</Form.Label>
          <select
            name="tipoIscrizioneCongresso"
            className={`form-control ${getInputClasses("tipoIscrizioneCongresso")}`}
            {...formik.getFieldProps("tipoIscrizioneCongresso")}
          >
            <option value="">Seleziona tipo...</option>
            {congressoOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          {formik.touched["tipoIscrizioneCongresso"] && formik.errors["tipoIscrizioneCongresso"] ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors["tipoIscrizioneCongresso"]}</div>
            </div>
          ) : null}
        </Form.Group>
      )}

      {/* Campi comuni per Congresso e Sponsorizzazione */}
      {(isCongresso || isSponsorizzazione) && (
        <>
          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields["dataInizio"].label}</Form.Label>
            <Form.Control
              type="date"
              name="dataInizio"
              min={minStartDateStr}
              className={getInputClasses("dataInizio")}
              {...formik.getFieldProps("dataInizio")}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              onBlur={(e) => {
                formik.handleBlur(e);
                formik.setFieldTouched("dataInizio", true, true);
              }}
            />
            {formik.touched["dataInizio"] && formik.errors["dataInizio"] ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors["dataInizio"]}</div>
              </div>
            ) : null}
            {!formik.errors["dataInizio"] && formik.values.dataInizio ? (
              (new Date(formik.values.dataInizio + "T00:00:00") < minTwentyOneObj) ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block text-warning">
                    Avviso: per assicurare la disponibilità del servizio, la data di inizio deve essere comunicata con almeno 21 giorni di preavviso.
                  </div>
                </div>
              ) : null
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields["dataFine"].label}</Form.Label>
            <Form.Control
              type="date"
              name="dataFine"
              min={formik.values.dataInizio || minStartDateStr}
              className={getInputClasses("dataFine")}
              {...formik.getFieldProps("dataFine")}
              onChange={(e) => {
                formik.handleChange(e);
                const startVal = formik.values.dataInizio;
                const endVal = e.target.value;
                if (startVal && endVal) {
                  const startDate = new Date(startVal + "T00:00:00");
                  const endDate = new Date(endVal + "T00:00:00");
                  if (endDate < startDate) {
                    formik.setFieldError("dataFine", "La data di fine deve essere uguale o successiva alla data di inizio");
                  } else {
                    formik.setFieldError("dataFine", undefined);
                  }
                }
              }}
              onBlur={(e) => {
                formik.handleBlur(e);
                formik.setFieldTouched("dataFine", true, true);
              }}
            />
            {formik.touched["dataFine"] && formik.errors["dataFine"] ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors["dataFine"]}</div>
              </div>
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields["titoloEvento"].label}</Form.Label>
            <Form.Control
              name="titoloEvento"
              placeholder={formFields["titoloEvento"].placeholder}
              className={getInputClasses("titoloEvento")}
              {...formik.getFieldProps("titoloEvento")}
            />
            {formik.touched["titoloEvento"] && formik.errors["titoloEvento"] ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors["titoloEvento"]}</div>
              </div>
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields["sede"].label}</Form.Label>
            <Form.Control
              name="sede"
              placeholder={formFields["sede"].placeholder}
              className={getInputClasses("sede")}
              {...formik.getFieldProps("sede")}
            />
            {formik.touched["sede"] && formik.errors["sede"] ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors["sede"]}</div>
              </div>
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields["segreteria"].label}</Form.Label>
            <Form.Control
              name="segreteria"
              placeholder={formFields["segreteria"].placeholder}
              className={getInputClasses("segreteria")}
              {...formik.getFieldProps("segreteria")}
            />
            {formik.touched["segreteria"] && formik.errors["segreteria"] ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors["segreteria"]}</div>
              </div>
            ) : null}
          </Form.Group>
        </>
      )}

      {/* Trasferta: solo Sede (luogo), Data Inizio, Data Fine */}
      {isTrasferta && (
        <>
          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields["sede"].label}</Form.Label>
            <Form.Control
              name="sede"
              placeholder={formFields["sede"].placeholder}
              className={getInputClasses("sede")}
              {...formik.getFieldProps("sede")}
            />
            {formik.touched["sede"] && formik.errors["sede"] ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors["sede"]}</div>
              </div>
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields["dataInizio"].label}</Form.Label>
            <Form.Control
              type="date"
              name="dataInizio"
              min={minStartDateStr}
              className={getInputClasses("dataInizio")}
              {...formik.getFieldProps("dataInizio")}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              onBlur={(e) => {
                formik.handleBlur(e);
                formik.setFieldTouched("dataInizio", true, true);
              }}
            />
            {formik.touched["dataInizio"] && formik.errors["dataInizio"] ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors["dataInizio"]}</div>
              </div>
            ) : null}
            {!formik.errors["dataInizio"] && formik.values.dataInizio ? (
              (new Date(formik.values.dataInizio + "T00:00:00") < minTwentyOneObj) ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block text-warning">
                    Avviso: per assicurare la disponibilità del servizio, la data di inizio deve essere comunicata con almeno 21 giorni di preavviso.
                  </div>
                </div>
              ) : null
            ) : null}
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields["dataFine"].label}</Form.Label>
            <Form.Control
              type="date"
              name="dataFine"
              min={formik.values.dataInizio || minStartDateStr}
              className={getInputClasses("dataFine")}
              {...formik.getFieldProps("dataFine")}
              onChange={(e) => {
                formik.handleChange(e);
                const startVal = formik.values.dataInizio;
                const endVal = e.target.value;
                if (startVal && endVal) {
                  const startDate = new Date(startVal + "T00:00:00");
                  const endDate = new Date(endVal + "T00:00:00");
                  if (endDate < startDate) {
                    formik.setFieldError("dataFine", "La data di fine deve essere uguale o successiva alla data di inizio");
                  } else {
                    formik.setFieldError("dataFine", undefined);
                  }
                }
              }}
              onBlur={(e) => {
                formik.handleBlur(e);
                formik.setFieldTouched("dataFine", true, true);
              }}
            />
            {formik.touched["dataFine"] && formik.errors["dataFine"] ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors["dataFine"]}</div>
              </div>
            ) : null}
          </Form.Group>
        </>
      )}
    </>
  );
};

export default ServizioDettagliForm;
